export const isValidDateRange = (fromDate, toDate) => {
  const from = new Date(`${fromDate}T00:00:00Z`);
  const to = new Date(`${toDate}T00:00:00Z`);
  const sameMonthAndYear = from.getUTCMonth() === to.getUTCMonth()
  && from.getUTCFullYear() === to.getUTCFullYear();
  const timeDifference = Math.abs(to - from);
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
  return sameMonthAndYear && daysDifference <= 31;
};

export default {};
